const UPDATE_RATING = 'classpass/ratings/UPDATE_RATING';
const UPDATE_COMMENT = 'classpass/ratings/UPDATE_COMMENT';
const INVALID_RATING = 'classpass/ratings/INVALID_RATING';
const RESET_RATING = 'classpass/ratings/RESET_RATING';

const getInitialState = () => ({ stars: 0, comment: ' ', invalid: false });

export const updateRating = stars => ({ type: UPDATE_RATING, data: stars });
export const updateComment = comment => ({ type: UPDATE_COMMENT, data: comment });
export const invalidRating = () => ({ type: INVALID_RATING });
export const resetRating = () => ({ type: RESET_RATING });

export default function reducer(state = getInitialState(), action = {}) {
  switch (action.type) {
    case UPDATE_RATING:
      return {
        ...state,
        stars: action.data,
        invalid: false,
      };
    case UPDATE_COMMENT:
      return {
        ...state,
        comment: action.data,
      };
    case INVALID_RATING:
      return {
        ...state,
        invalid: true,
      };
    case RESET_RATING:
      return {
        ...state,
        stars: 0,
        comment: '',
        invalid: false,
      };
    default:
      return state;
  }
}
